export function toLocalInputFormat(dateString: string): string {
	const date = new Date(dateString);

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');

	// Calcul du décalage horaire local (en minutes)
	const timezoneOffset = -date.getTimezoneOffset(); // négatif pour les fuseaux à l'est de UTC
	const sign = timezoneOffset >= 0 ? '+' : '-';
	const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
	const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
	const offset = `${sign}${offsetHours}:${offsetMinutes}`;

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offset}`;
}
